// extracted by mini-css-extract-plugin
export var emptyState = "_6d-d";
export var statCard = "_6d-c";
export var table = "_6d-0";
export var tableCell = "_6d-4";
export var tableCellClickable = "_6d-5 _6d-4";
export var tableCellDefault = "_6d-6 _6d-4";
export var tableCellEmpty = "_6d-8";
export var tableCellWithValue = "_6d-7";
export var tableContainer = "_6d-e";
export var tableHeaderWeight = "_6d-1";
export var tableHeaderZone = "_6d-2";
export var tableRowHeader = "_6d-3";
export var viewModeButton = "_6d-9";
export var viewModeButtonActive = "_6d-a _6d-9";
export var viewModeButtonInactive = "_6d-b _6d-9";